module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_jing.fe5e8.png";